import { Box, Button, Chip, Collapse, Typography, useTheme } from '@mui/material'
import styled from 'styled-components'
import CustomButton from '../../../../components/ui/CustomButton'

export const HeadingContainer = styled(Box).attrs(() => ({
  sx: {
    marginBottom: { xs: '12px', sm: '16px', md: '20px' },
  },
}))(() => ({}))

export const HeadingText = styled(Typography).attrs(() => {
  const theme = useTheme()
  return {
    variant: 'h4',
    sx: {
      fontSize: { xs: '22px', sm: '28px', md: '36px' },
      fontWeight: 700,
      color: theme.palette.grey[900],
      lineHeight: 1.3,
    },
  }
})(() => ({}))

export const HeadingNumber = styled('span').attrs(() => {
  const theme = useTheme()
  return {
    style: {
      color: theme.palette.primary.main,
    },
  }
})(() => ({}))

export const CategoryChipsContainer = styled(Box).attrs(() => ({
  sx: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: { xs: '6px', sm: '8px' },
    marginBottom: { xs: '16px', sm: '20px', md: '28px' },
  },
}))(() => ({}))

export const CategoryChip = styled(Chip).attrs(() => {
  const theme = useTheme()
  return {
    sx: {
      borderColor: theme.palette.primary.main,
      color: theme.palette.primary.main,
      fontSize: { xs: '12px', sm: '14px' },
      fontWeight: 500,
      borderRadius: '20px',
      padding: { xs: '2px 6px', sm: '4px 8px' },
      height: 'auto',
    },
  }
})(() => ({}))

export const SectionCard = styled(Box).attrs(() => {
  const theme = useTheme()
  return {
    sx: {
      backgroundColor: theme.palette.grey[50],
      borderRadius: '16px',
      padding: { xs: '16px', sm: '20px', md: '24px' },
      marginBottom: '16px',
    },
  }
})(() => ({}))

export const SectionHeader = styled(Box).attrs(() => ({
  sx: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    cursor: 'pointer',
    marginBottom: '8px',
  },
}))(() => ({}))

export const SectionTitle = styled(Typography).attrs(() => {
  const theme = useTheme()
  return {
    variant: 'h6',
    sx: {
      fontSize: { xs: '20px', sm: '22px', md: '24px' },
      fontWeight: 700,
      color: theme.palette.grey[900],
    },
  }
})(() => ({}))

export const SectionSubtitle = styled(Typography).attrs(() => {
  const theme = useTheme()
  return {
    variant: 'body2',
    sx: {
      fontSize: '14px',
      color: theme.palette.grey[500],
      marginTop: '4px',
    },
  }
})(() => ({}))

export const RestaurantInfoCard = styled(Box).attrs(() => {
  const theme = useTheme()
  return {
    sx: {
      display: 'flex',
      gap: '16px',
      padding: '16px',
      backgroundColor: theme.palette.common.white,
      borderRadius: '12px',
      border: `1px solid ${theme.palette.grey[200]}`,
    },
  }
})(() => ({}))

export const RestaurantImage = styled('img').attrs(() => ({
  style: {
    width: '120px',
    height: '120px',
    borderRadius: '8px',
    objectFit: 'cover',
  },
}))(() => ({}))

export const RestaurantDetails = styled(Box).attrs(() => ({
  sx: {
    display: 'flex',
    flexDirection: 'column',
    gap: '4px',
    flex: 1,
  },
}))(() => ({}))

export const RestaurantName = styled(Typography).attrs(() => {
  const theme = useTheme()
  return {
    variant: 'h6',
    sx: {
      fontSize: '18px',
      fontWeight: 700,
      color: theme.palette.grey[900],
    },
  }
})(() => ({}))

export const RestaurantInfo = styled(Typography).attrs(() => {
  const theme = useTheme()
  return {
    variant: 'body2',
    sx: {
      fontSize: '14px',
      color: theme.palette.grey[600],
      lineHeight: 1.5,
    },
  }
})(() => ({}))

export const DishRecommendationsButton = styled(CustomButton).attrs(() => {
  const theme = useTheme()
  return {
    title: 'Dish Recommendations',
    sx: {
      backgroundColor: theme.palette.primary.dark,
      color: theme.palette.common.white,
      width: '100%',
      padding: '16px',
      fontSize: '16px',
      fontWeight: 600,
      borderRadius: '12px',
      marginBottom: '16px',
      textTransform: 'none',
      '&:hover': {
        backgroundColor: theme.palette.primary.main,
      },
    },
  }
})(() => ({}))

export const ButtonsContainer = styled(Box).attrs(() => ({
  sx: {
    display: 'flex',
    gap: { xs: '10px', sm: '12px' },
    flexDirection: { xs: 'column', sm: 'row' },
    maxWidth: '480px',
    margin: '0 auto',
  },
}))(() => ({}))

export const ScanAnotherMenuButton = styled(Button).attrs(() => {
  const theme = useTheme()
  return {
    variant: 'contained',
    sx: {
      flex: 1,
      padding: { xs: '10px 16px', sm: '12px 18px' },
      fontSize: { xs: '14px', sm: '15px' },
      fontWeight: 600,
      borderRadius: { xs: '10px', sm: '12px' },
      textTransform: 'none',
      backgroundColor: theme.palette.primary.main,
      color: theme.palette.common.white,
      '&:hover': {
        backgroundColor: theme.palette.primary.dark,
      },
    },
  }
})(() => ({}))

export const SaveMenuButton = styled(Button).attrs(() => {
  const theme = useTheme()
  return {
    variant: 'outlined',
    sx: {
      flex: 1,
      padding: { xs: '10px 16px', sm: '12px 18px' },
      fontSize: { xs: '14px', sm: '15px' },
      fontWeight: 600,
      borderRadius: { xs: '10px', sm: '12px' },
      textTransform: 'none',
      borderColor: theme.palette.grey[800],
      color: theme.palette.grey[800],
      '&:hover': {
        borderColor: theme.palette.grey[900],
        backgroundColor: theme.palette.grey[50],
      },
    },
  }
})(() => ({}))

export const CollapsibleContent = styled(Collapse).attrs(() => ({
  sx: {
    marginTop: '8px',
  },
}))(() => ({}))

export const SubheadingText = styled(Typography).attrs(() => {
  const theme = useTheme()
  return {
    variant: 'body1',
    sx: {
      fontSize: { xs: '15px', sm: '16px', md: '17px' },
      fontWeight: 400,
      color: theme.palette.grey[500],
      marginBottom: { xs: '20px', sm: '24px', md: '28px' },
    },
  }
})(() => ({}))

export const DishListContainer = styled(Box).attrs(() => ({
  sx: {
    display: 'flex',
    flexDirection: 'column',
    gap: 0,
    maxWidth: '650px',
    margin: '0 auto',
    marginBottom: { xs: '24px', sm: '28px', md: '32px' },
  },
}))(() => ({}))

export const DishCard = styled(Box).attrs(() => {
  const theme = useTheme()
  return {
    sx: {
      display: 'flex',
      flexDirection: 'column',
      gap: { xs: '6px', sm: '8px' },
      padding: { xs: '20px 0', sm: '24px 0', md: '26px 0' },
      width: '100%',
      borderBottom: `1px solid ${theme.palette.grey[200]}`,
      '&:last-child': {
        borderBottom: 'none',
      },
    },
  }
})(() => ({}))

export const DishImageContainer = styled(Box).attrs(() => ({
  sx: {
    position: 'relative',
    width: '100%',
    borderRadius: '16px',
    overflow: 'hidden',
    aspectRatio: '16/9',
  },
}))(() => ({}))

export const DishImage = styled('img').attrs(() => ({
  style: {
    width: '100%',
    height: '100%',
    objectFit: 'cover',
  },
}))(() => ({}))

export const DescriptionChipContainer = styled(Box).attrs(() => ({
  sx: {
    position: 'absolute',
    top: { xs: '12px', sm: '16px' },
    left: { xs: '12px', sm: '16px' },
  },
}))(() => ({}))

export const DishInfo = styled(Box).attrs(() => ({
  sx: {
    display: 'flex',
    flexDirection: 'column',
    gap: '4px',
  },
}))(() => ({}))

export const DishName = styled(Typography).attrs(() => {
  const theme = useTheme()
  return {
    variant: 'h6',
    sx: {
      fontSize: { xs: '16px', sm: '17px', md: '18px' },
      fontWeight: 700,
      color: theme.palette.grey[900],
      lineHeight: 1.4,
      marginBottom: '2px',
    },
  }
})(() => ({}))

export const DishCategory = styled(Typography).attrs(() => {
  const theme = useTheme()
  return {
    variant: 'body2',
    sx: {
      fontSize: { xs: '13px', sm: '14px' },
      fontWeight: 400,
      color: theme.palette.grey[500],
      lineHeight: 1.4,
    },
  }
})(() => ({}))

export const DishPrice = styled(Typography).attrs(() => {
  const theme = useTheme()
  return {
    variant: 'body1',
    sx: {
      fontSize: { xs: '15px', sm: '16px' },
      fontWeight: 400,
      color: theme.palette.grey[500],
      marginTop: '4px',
    },
  }
})(() => ({}))

export const DishDescription = styled(Typography).attrs(() => {
  const theme = useTheme()
  return {
    variant: 'body2',
    sx: {
      fontSize: { xs: '14px', sm: '15px' },
      fontWeight: 400,
      color: theme.palette.grey[700],
      lineHeight: 1.5,
      marginTop: '6px',
    },
  }
})(() => ({}))

export const BottomInfoContainer = styled(Box).attrs(() => ({
  sx: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '8px',
    marginBottom: { xs: '20px', sm: '24px' },
  },
}))(() => ({}))

export const BottomInfoText = styled(Typography).attrs(() => {
  const theme = useTheme()
  return {
    variant: 'body1',
    sx: {
      fontSize: { xs: '15px', sm: '16px' },
      fontWeight: 400,
      color: theme.palette.grey[600],
      textAlign: 'center',
    },
  }
})(() => ({}))

export const InfoIcon = styled('div').attrs(() => {
  const theme = useTheme()
  return {
    style: {
      width: '20px',
      height: '20px',
      borderRadius: '50%',
      border: `2px solid ${theme.palette.warning.main}`,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      fontSize: '14px',
      fontWeight: 700,
      color: theme.palette.warning.main,
    },
  }
})(() => ({}))

export const ImproveResultsButton = styled(Button).attrs(() => {
  const theme = useTheme()
  return {
    variant: 'outlined',
    sx: {
      flex: 1,
      padding: { xs: '10px 16px', sm: '12px 18px' },
      fontSize: { xs: '14px', sm: '15px' },
      fontWeight: 600,
      borderRadius: { xs: '10px', sm: '12px' },
      textTransform: 'none',
      borderColor: theme.palette.grey[800],
      color: theme.palette.grey[800],
      '&:hover': {
        borderColor: theme.palette.grey[900],
        backgroundColor: theme.palette.grey[50],
      },
    },
  }
})(() => ({}))
